export const enum DialogContentType {
    PUBLIC_BETA = 'publicBetaAgreement',
    SERVICE_AGREEMENT = 'serviceAgreement',
    USER_GUIDE = 'userGuide',
    PRIVACY = 'privacy',
    PROHIBITED_CONDUCT = 'prohibitedConduct',
}
